export enum ProductImportationStatusEnum {
    Received = 1,
    ReadingFile = 2,
    ValidatingProducts = 3,
    ValidatedProducts = 4,
    SavingProducts = 5,
    Completed = 6,
    Error = 7,
    Aborted = 8
}